


import { IFetchRequest, injectFetch, Method, ResponseTypes } from '../../interface/util';
import { injectConfigAPI } from '../../interface/config';
import { IMediumDiffRequestStatus, IMediaDiffResponse } from './interface';

interface IMediaDiffRequest {
    requestDto: {
        siteId: number,
        hash: string,
        requests: Array<{id:string, mediumHash: string}>
    };
}

function _request(apiUrl: string, extension: string, authToken: string, siteId: number, siteHash: string = "", existingMedia: Array<IMediumDiffRequestStatus> = []) : IFetchRequest {
    const mapMediumToBodyRequest = (medium: IMediumDiffRequestStatus): {id:string, mediumHash:string} => ({
        id: medium.id,
        mediumHash: medium.mediumHash
    })

    const body: IMediaDiffRequest = {
        requestDto: {
            siteId,
            hash: siteHash,
            requests: existingMedia.map(medium => mapMediumToBodyRequest(medium)),
        }
    }

    const req: IFetchRequest = {
        url: apiUrl + extension,
        method: 'POST' as Method,
        headers: [
            { name:'Authorization', value: `Bearer ${authToken}` },
            { name:'Content-Type', value: 'application/json' },
        ],
        body: JSON.stringify(body),
        expectedResponseType: 'json' as ResponseTypes,
    };

    return req;
}

function getMediaDiff(authToken: string, siteId: number, siteHash: string = "", existingMedia: Array<IMediumDiffRequestStatus> = []) : Promise<IMediaDiffResponse> {
    return new Promise(async function(resolve, reject) {
        try {
            const fetcher = await injectFetch();
            const config = injectConfigAPI();

            const req = _request(authToken, config.url, config.extension.mediaDiff, siteId, siteHash, existingMedia);
        
            const response = await fetcher(req);

            resolve(response.payload as IMediaDiffResponse);
        } catch (error) {
            reject(error);
        }
    });
}

export default getMediaDiff;
